export default __webpack_public_path__ + "static/media/bannervideo3.5adc4110.mp4";